/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import * as msal from "@azure/msal-browser";

import {
  idTokenRequest,
  policyAuthorities,
  policyNames,
} from "./authCodePolicies";
import logger from "../logger";

let msalInstance;

export const initializeMsalInstance = (callback) => {
  msalInstance = new msal.PublicClientApplication({
    auth: {
      clientId: window.env.AADB2C_CLIENT_ID,
      authority: policyAuthorities.emailSignIn,
      knownAuthorities: [window.env.AADB2C_AUTHORITY_DOMAIN],
      validateAuthority: false,
      redirectUri: window.env.AADB2C_REDIRECT_URI,
      postLogoutRedirectUri: window.env.AADB2C_POST_LOGOUT_REDIRECT_URI,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      navigateFrameWait: 0,
      logger: new msal.Logger(
        (logLevel, message) => {
          logger.error(message);
        },
        {
          level: msal.LogLevel.Error,
        }
      ),
    },
  });

  const handleResponse = async (tokenResponse) => {
    if (tokenResponse?.idTokenClaims?.tfp === policyNames.resetPassword) {
      // We need to reject id tokens that were not issued with the default
      // sign-in policy, such as with the reset password policy
      msalInstance.logoutRedirect();
    } else {
      const currentAccounts = msalInstance.getAllAccounts();
      if (!currentAccounts || currentAccounts.length < 1) {
        await msalInstance.loginRedirect(idTokenRequest);
      } else {
        const activeAccount = currentAccounts[0];
        msalInstance.setActiveAccount(activeAccount);
        callback();
      }
    }
  };

  const handleError = (error) => {
    let message = "";

    if (error.errorMessage !== undefined) {
      message = error.errorMessage;
    } else if (error.message !== undefined) {
      message = error.message;
    }

    if (message.indexOf("AADB2C90118") > -1) {
      msalInstance.loginRedirect({
        authority: policyAuthorities.resetPassword,
      });
    } else {
      logger.error(error);
      msalInstance.loginRedirect(idTokenRequest);
    }
  };

  msalInstance.handleRedirectPromise().then(handleResponse).catch(handleError);

  return msalInstance;
};

export const getMsalInstance = () => msalInstance;
